import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getAllArtistStory = () => {
  return axios.get(URL_PREFIX + '/artist-stories/')
}

export const postArtistStory = (params) => {
  return axios.post(URL_PREFIX + '/artist-stories/', params)
}

export const getArtistStory = (artist) => {
  return axios.get(URL_PREFIX + '/artist-stories/' + artist + '/')
}

export const patchArtistStory = (artist, params) => {
  return axios.patch(URL_PREFIX + '/artist-stories/' + artist + '/', params)
}

export const deleteArtistStory = (artist) => {
  return axios.delete(URL_PREFIX + '/artist-stories/' + artist + '/')
}
